<template>
  <div>
    <div v-if="edit && !dados.id" class="loading-form" style="min-height: 130px;">
      <img src="/public/img/loading-bar.gif" />
    </div>

    <el-form @submit.native.prevent="onSubmit" v-if="!edit || dados.id" :model="dados" ref="dados" label-position="top">
      <div v-if="!edit || dados.id">
        <el-row :gutter="10">
          <el-col :xs="24" :sm="6" :md="6">
            <el-form-item label="Situação" prop="ativo" :rules="[$requiredChange]" key="ativo">
              <el-select v-model="dados.ativo">
                <el-option :key="true" label="ATIVO" :value="true"></el-option>
                <el-option :key="false" label="INATIVO" :value="false"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6" :md="6">
            <el-form-item label="Perecível" prop="perecivel" :rules="[$requiredChange]" key="perecivel">
              <el-select v-model="dados.perecivel">
                <el-option :key="true" label="SIM" :value="true"></el-option>
                <el-option :key="false" label="NÃO" :value="false"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item label="Categoria" prop="categoria_id" key="categoria_id">
              <el-select v-model="dados.categoria_id" filterable clearable placeholder="Selecione a categoria" style="width: 100%;">
                <el-option v-for="c in categorias" :key="c.id" :label="c.nome" :value="c.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="Tipo de Alimento" prop="tipo_alimento_id" key="tipo_alimento_id">
              <el-select v-model="dados.tipo_alimento_id" filterable clearable placeholder="Selecione o tipo de alimento" style="width: 100%;">
                <el-option v-for="t in tiposAlimento" :key="t.id" :label="t.nome" :value="t.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :xs="24" :sm="18" :md="18">
            <el-form-item label="Nome" prop="nome" :rules="[$requiredBlur]" key="nome">
              <el-input v-model="dados.nome" maxlength="191" v-on:blur="formatUpper('nome')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6" :md="6">
            <el-form-item label="Unidade medida" prop="unidade_medida" :rules="[$requiredChange]" key="unidade_medida">
              <el-select v-model="dados.unidade_medida" placeholder="Selecione" style="width: 100%;">
                <el-option v-for="u in unidadesMedida" :key="u" :label="u" :value="u"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :xs="24" :sm="6" :md="6">
            <el-form-item label="Validade (dias)" prop="validade_dias" key="validade_dias">
              <el-input v-model="dados.validade_dias" maxlength="6"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6" :md="6">
            <el-form-item label="Fonte dos dados" prop="fonte_dados" key="fonte_dados">
              <el-select v-model="dados.fonte_dados" clearable>
                <el-option label="TACO" value="TACO"></el-option>
                <el-option label="IBGE" value="IBGE"></el-option>
                <el-option label="MANUAL" value="manual"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-collapse v-model="collapseAtivo">
          <el-collapse-item title="Informação Nutricional (por 100g)" name="nutricional">
            <el-row :gutter="10">
              <el-col :xs="24" :sm="6" :md="6">
                <el-form-item label="Energia (kcal)" prop="kcal_100g" key="kcal_100g">
                  <el-input v-model="dados.kcal_100g" maxlength="10"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="6" :md="6">
                <el-form-item label="Carboidratos (g)" prop="carboidrato_g" key="carboidrato_g">
                  <el-input v-model="dados.carboidrato_g" maxlength="10"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="6" :md="6">
                <el-form-item label="Proteínas (g)" prop="proteina_g" key="proteina_g">
                  <el-input v-model="dados.proteina_g" maxlength="10"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="6" :md="6">
                <el-form-item label="Lipídios (g)" prop="lipidio_g" key="lipidio_g">
                  <el-input v-model="dados.lipidio_g" maxlength="10"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :xs="24" :sm="6" :md="6">
                <el-form-item label="Fibras (g)" prop="fibra_g" key="fibra_g">
                  <el-input v-model="dados.fibra_g" maxlength="10"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="6" :md="6">
                <el-form-item label="Sódio (mg)" prop="sodio_mg" key="sodio_mg">
                  <el-input v-model="dados.sodio_mg" maxlength="12"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="6" :md="6">
                <el-form-item label="Açúcar adicionado (g)" prop="acucar_adicionado_g" key="acucar_adicionado_g">
                  <el-input v-model="dados.acucar_adicionado_g" maxlength="10"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="6" :md="6">
                <el-form-item label="Gordura saturada (g)" prop="gordura_saturada_g" key="gordura_saturada_g">
                  <el-input v-model="dados.gordura_saturada_g" maxlength="10"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :xs="24" :sm="6" :md="6">
                <el-form-item label="Custo" prop="custo" key="custo">
                  <el-input v-model="dados.custo" maxlength="20" placeholder="Ex.: 5,90"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-collapse-item>
        </el-collapse>

        <el-row :gutter="10">
          <el-col :xs="24">
            <el-form-item class="u-text-right u-mt-15">
              <el-button type="primary" id="btn-alimento" native-type="submit">SALVAR</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>
  </div>
</template>

<script>
export default {
  props: ['paramId'],
  data: () => ({
    edit: false,
    collapseAtivo: [],
    categorias: [],
    tiposAlimento: [],
    unidadesMedida: ['UN', 'KG', 'G', 'L', 'ML', 'PCT', 'CX', 'FD'],
    dados: {
      id: '',
      nome: '',
      categoria_id: '',
      tipo_alimento_id: '',
      unidade_medida: '',
      perecivel: false,
      validade_dias: '',
      ativo: true,
      kcal_100g: '',
      carboidrato_g: '',
      proteina_g: '',
      lipidio_g: '',
      fibra_g: '',
      sodio_mg: '',
      acucar_adicionado_g: '',
      gordura_saturada_g: '',
      custo: '',
      fonte_dados: ''
    }
  }),
  mounted () { this.loadCategorias(); this.loadTiposAlimento() },
  methods: {
    loadCategorias () {
      this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/merenda/categoria/getAll`, { ativo: true }, this.$store.getters.getHeaderAuth)
        .then(response => { this.categorias = response.data || [] })
        .catch((error) => { this.$store.commit('throwException', error) })
    },
    loadTiposAlimento () {
      this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/merenda/tipo-alimento/getAll`, { ativo: true }, this.$store.getters.getHeaderAuth)
        .then(response => { this.tiposAlimento = response.data || [] })
        .catch((error) => { this.$store.commit('throwException', error) })
    },
    getById (id) {
      this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/merenda/alimento/getById/` + id, this.$store.getters.getHeaderAuth)
        .then(response => { this.dados = JSON.parse(JSON.stringify(response.data)) })
        .catch((error) => { this.$store.commit('throwException', error) })
    },
    onSubmit () {
      document.getElementById("btn-alimento").focus()
      this.$refs.dados.validate((valid) => {
        if (!valid) return window.eventBus.$emit('alert', { msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning' })
        window.eventBus.$emit('loading', true)
        const url = this.edit
          ? `${this.$store.state.config.baseUrlApi}/api/merenda/alimento/update/${this.dados.id}`
          : `${this.$store.state.config.baseUrlApi}/api/merenda/alimento/store`
        this.$axios.post(url, this.dados, this.$store.getters.getHeaderAuth)
          .then(response => {
            window.eventBus.$emit('loading', false)
            if (response.data && response.data.erro) {
              const msg = typeof response.data.erro === 'string' ? response.data.erro : (response.data.erro.text || 'Erro ao salvar.')
              return window.eventBus.$emit('alert', { msg, type: 'warning' })
            }
            window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
            this.$emit('onSubmitAlimento')
          }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error) })
      })
    },
    formatUpper (field) {
      if (!this.dados[field]) return
      this.dados[field] = this.$removerAcentos(String(this.dados[field]).toUpperCase())
    }
  },
  watch: {
    paramId: {
      immediate: true,
      handler (value) {
        if (value) {
          this.getById(value)
          this.edit = true
        }
      }
    }
  }
}
</script>
